<app-kiosk-page></app-kiosk-page>